<template>
  <app-page form class="specialbook-period workspace">
    <h1 class="title mb-4">予約日時を選択して下さい</h1>

    <card-book-car class="mb-4"/>

    <v-card
      tag="form"
      @submit.prevent="onSubmit"
    >
      <v-card-text>
        <h2 class="mt-4 mb-3">ご利用日程</h2>
        <div class="guide mb-4 caption">
          <p>
            当社貸出カレンダーに準じ、期間は最長1ヶ月までご利用いただけます。
          </p>
        </div>
        <period-time
          caption="出発日時"
          v-model="begin"
          :dates="dates"
          :allow="allowBegin"
          @change="onChangeBegin"
        />
        <period-time
          caption="帰着日時"
          v-model="end"
          :dates="dates"
          :allow="allowEnd"
        />
      </v-card-text>

      <v-card-actions class="px-4">
        <v-spacer/>
        <v-btn type="submit" color="primary">次へ</v-btn>
      </v-card-actions>
    </v-card>

    <alert-login :value="!logined"/>
  </app-page>
</template>

<script>
import ShopBase from '@/app/special/mixins/ShopBase'
import PeriodTime from './PeriodTime'
import AlertLogin from './AlertLogin'
import CardBookCar from '../BookComponents/CardBookCar'

import { mapGetters, mapActions } from 'vuex'
import * as time from '@/libs/time'
import * as calendar from '@/app/special/libs/calendar'

export default {
  name: 'BookPeriod',
  mixins: [
    ShopBase('予約日時')
  ],
  components: {
    PeriodTime,
    AlertLogin,
    CardBookCar
  },
  data () {
    return {
      // 出発日時, 帰着日時
      begin: new Date(),
      end: new Date(),

      // 店舗の営業カレンダー
      dates: {}
    }
  },
  computed: {
    ...mapGetters('login', [
      'logined'
    ]),
    ...mapGetters('shop', [
      'm_calendar'
    ]),
    ...mapGetters('book', [
      'bookAllow',
      'bookPeriod'
    ]),

    allowBegin () {
      // 基準は bookAllow
      const begin = time.clone(this.bookAllow.begin)
      const end = time.clone(this.bookAllow.end)

      // end を1時間早める: 予約は最低1時間
      end.setHours(end.getHours() - 1)

      return { begin, end }
    },

    allowEnd () {
      // 基準は出発日時
      let begin = time.clone(this.begin)
      let end = time.clone(this.begin)

      // 最低1時間
      begin.setHours(begin.getHours() + 1)

      // begin を営業時間で成約する
      const cal = calendar.create(this.m_calendar, 'daysand')
      const t = cal.testClosed(begin, false, false)
      if (t) {
        // begin が営業時間を超えていたとき、翌営業開始日時にする
        begin = t.end
      }

      // 最長1ヶ月
      const m = end.getMonth() + 1
      const d = end.getDate()
      end.setMonth(m, d)
      if (end.getMonth() !== m) {
        // end.setMonth() の結果、月を跨いでいたら月末に修正
        end.setMonth(m + 1, 0)
      }

      // bookAllow.end で制約する
      if (this.bookAllow.end < end) {
        end = time.clone(this.bookAllow.end)
      }

      return { begin, end }
    }
  },
  created () {
    this.addFetcher(() => {
      // 編集項目を data にコピーする
      this.begin = time.clone(this.bookPeriod.begin)
      this.end = time.clone(this.bookPeriod.end)

      // 店舗の営業カレンダーを作成する
      this.dates = { ...this.m_calendar.dates }
      return true
    })
  },
  methods: {
    ...mapActions('book', [
      'setBookPeriod'
    ]),

    // 出発日時に応じて適切な帰着日時を維持する
    onChangeBegin () {
      const allow = this.allowEnd

      if (this.end < allow.begin) {
        this.end = time.clone(allow.begin)
      } else if (this.end > allow.end) {
        this.end = time.clone(allow.end)
      }
    },

    async onSubmit () {
      // 入力値を保存する
      const rval = await this.setBookPeriod({
        begin: this.begin,
        end: this.end
      })

      if (!rval) {
        return
      }

      // 次のページへ
      this.$router.push({ name: 'book-option' })
    }
  }
}
</script>
